"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokensComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_redux_1 = require("react-redux");
var useCopy_1 = __importDefault(require("../../../../hooks/useCopy"));
var main_1 = require("../../../../reducers/slices/main");
var token_management_1 = __importDefault(require("../configurations/token_management/token_management"));
var TokensComponent = function () {
    var _a;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, useCopy_1.default)(), isCopied = _b.isCopied, copyToClipboard = _b.copyToClipboard;
    var inputRef = react_1.default.useRef(null);
    var client = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).client;
    (0, react_1.useEffect)(function () {
        if (isCopied) {
            dispatch((0, main_1.setMessageModal)({
                title: "Success!",
                messages: ["Copied to clipboard!"],
                onClose: function () {
                    dispatch((0, main_1.setContentModal)(null));
                },
            }));
        }
    }, [isCopied]);
    (0, react_1.useEffect)(function () {
        if (inputRef.current) {
            var inputs = inputRef.current.getElementsByClassName("grid");
            for (var i = 0; i < inputs.length; i++) {
                inputs[i].className = "grid w-full";
            }
        }
    }, [inputRef.current]);
    var handleOpenTokenManagement = function () {
        dispatch((0, main_1.setContentModal)({
            title: "Token Management Settings",
            content: (0, jsx_runtime_1.jsx)(token_management_1.default, {}),
        }));
    };
    return ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.BoxControl, __assign({ className: "w-full bg-white", borderColor: "border-transparent" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ ref: inputRef, className: "flex lg:flex-col gap-6 my-3" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-row gap-2 flex-1 items-center" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { borderColor: "border-borders", icon: pro_light_svg_icons_1.faCog, size: "large", onClick: handleOpenTokenManagement }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.TextInputControl, { label: "Client token", type: "password", value: client === null || client === void 0 ? void 0 : client.token, borderColor: "border-borders", size: "medium", textColor: "text-dark", disabled: true }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { borderColor: "border-borders", icon: pro_light_svg_icons_1.faCopy, size: "large", onClick: function () {
                                copyToClipboard(client === null || client === void 0 ? void 0 : client.token);
                            } })] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-row gap-2 flex-grow" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.TextInputControl, { label: "Payment token", type: "password", value: (_a = client === null || client === void 0 ? void 0 : client.integration_settings) === null || _a === void 0 ? void 0 : _a.payment_engine_token, borderColor: "border-borders", disabled: true }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { borderColor: "border-borders", icon: pro_light_svg_icons_1.faCopy, size: "large", onClick: function () {
                                var _a;
                                copyToClipboard((_a = client === null || client === void 0 ? void 0 : client.integration_settings) === null || _a === void 0 ? void 0 : _a.payment_engine_token);
                            } })] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-row gap-2" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.TextInputControl, { label: "Client ID", type: "password", borderColor: "border-borders", value: client === null || client === void 0 ? void 0 : client._id, disabled: true }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faCopy, borderColor: "border-borders", size: "large", onClick: function () {
                                copyToClipboard(client === null || client === void 0 ? void 0 : client._id);
                            } })] }))] })) })));
};
exports.TokensComponent = TokensComponent;
